// extracted by mini-css-extract-plugin
module.exports = {"mobile":"500px","tablet":"768px","content":"InnerLayout_content__jqAoh","container":"InnerLayout_container__hI05I","divider":"InnerLayout_divider__ZG3wj"};